import Swal from 'sweetalert2';

export class MerlinForm {
  #rootElement;
  #MESSAGE_SELECTOR = '.mf-successmsg, .mf-errormsg';

  constructor(element) {
    this.#rootElement = element;
    this.#startAlertObserver();
  }

  /**
   * Starts a MutationObserver to watch for the success or error message
   * elements to be dynamically inserted by the external Merlin Form script.
   * This is a generic function to handle observing dynamic content.
   */
  #startAlertObserver() {
    // Use the class field
    if (this.#rootElement.querySelector(this.#MESSAGE_SELECTOR)) {
      this.#showSweetAlert();
      return;
    }

    // Configuration for the observer: watch for new children in the subtree
    const config = { childList: true, subtree: true };

    const observerCallback = (mutationsList, observer) => {
      if (this.#rootElement.querySelector(this.#MESSAGE_SELECTOR)) {
        this.#showSweetAlert();
        observer.disconnect(); // Stop observing once the element is found
      }
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(this.#rootElement, config);
  }

  #showSweetAlert() {
    const messageElement = this.#rootElement.querySelector(this.#MESSAGE_SELECTOR);
    if (!messageElement) return;

    messageElement.hidden = true;
    Swal.fire({
      icon: messageElement.classList.contains('mf-successmsg') ? 'success' : 'error',
      title: '',
      html: messageElement.innerHTML
    });
  }
}
